import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon, PlayIcon, SearchIcon, FileTextIcon, CheckCircleIcon, TrendingUpIcon, BellIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-16 md:pt-48 md:pb-32 overflow-hidden bg-gray-50/50" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-69">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-70">
          {/* Left Content */}
          <div className="max-w-2xl" data-id="element-71">
            <h1 className="font-sans text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.1] text-gray-900 tracking-tight font-bold mb-8" data-id="element-72">
              Экспертный ИИ для <br className="hidden md:block" data-id="element-73" />
              работы с документами
            </h1>

            <p className="text-lg md:text-xl text-gray-500 leading-relaxed mb-10 max-w-lg" data-id="element-74">
              ScanMind специализируется на легковесных технологиях OCR и
              интеллектуальном поиске. Превращайте статичные PDF-документы в
              доступную и структурированную базу знаний — сокращая сложные
              задачи с часов до минут.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-75">
              <Button variant="primary" size="lg" className="group" data-id="element-76">
                Запросить демо
                <div className="ml-2 bg-white/20 rounded-md p-1 group-hover:bg-white/30 transition-colors" data-id="element-77">
                  <ArrowRightIcon className="w-3 h-3" data-id="element-78" />
                </div>
              </Button>
              <Button variant="secondary" size="lg" data-id="element-79">
                Смотреть видео
                <PlayIcon className="ml-2 w-4 h-4 fill-current" data-id="element-80" />
              </Button>
            </div>
          </div>

          {/* Right Visual — Stylized Dashboard Illustration */}
          <div className="relative h-[400px] md:h-[560px] w-full flex items-center justify-center" data-id="element-81">
            {/* Main browser/app frame */}
            <div className="relative w-full max-w-[480px] bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden" data-id="element-82">
              {/* Browser top bar */}
              <div className="flex items-center gap-2 px-4 py-3 bg-gray-100 border-b border-gray-200" data-id="element-83">
                <div className="flex gap-1.5" data-id="element-84">
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-300" data-id="element-85"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-300" data-id="element-86"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-300" data-id="element-87"></div>
                </div>
                <div className="flex-1 mx-4" data-id="element-88">
                  <div className="bg-white border border-gray-200 rounded-md px-3 py-1.5 flex items-center gap-2" data-id="element-89">
                    <SearchIcon className="w-3 h-3 text-gray-400" data-id="element-90" />
                    <span className="text-xs text-gray-400" data-id="element-91">
                      Поиск документов...
                    </span>
                  </div>
                </div>
              </div>

              {/* Dashboard content */}
              <div className="flex" data-id="element-92">
                {/* Sidebar hint */}
                <div className="hidden sm:flex w-12 bg-gray-900 flex-col items-center py-4 gap-4" data-id="element-93">
                  <div className="w-6 h-6 rounded bg-blue-800 flex items-center justify-center" data-id="element-94">
                    <span className="text-white text-[10px] font-bold" data-id="element-95">S</span>
                  </div>
                  <div className="w-5 h-5 rounded bg-gray-700" data-id="element-96"></div>
                  <div className="w-5 h-5 rounded bg-gray-700" data-id="element-97"></div>
                  <div className="w-5 h-5 rounded bg-gray-700" data-id="element-98"></div>
                  <div className="mt-auto w-5 h-5 rounded bg-gray-700" data-id="element-99"></div>
                </div>

                {/* Main content area */}
                <div className="flex-1 p-4 space-y-4" data-id="element-100">
                  {/* Stats row */}
                  <div className="grid grid-cols-3 gap-3" data-id="element-101">
                    <div className="bg-gray-50 rounded-lg p-3" data-id="element-102">
                      <div className="text-[10px] text-gray-500 mb-1" data-id="element-103">
                        Обработано
                      </div>
                      <div className="text-sm font-bold text-gray-900" data-id="element-104">
                        12 847
                      </div>
                      <div className="text-[10px] text-emerald-600 font-medium" data-id="element-105">
                        +12,5%
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3" data-id="element-106">
                      <div className="text-[10px] text-gray-500 mb-1" data-id="element-107">
                        Точность
                      </div>
                      <div className="text-sm font-bold text-gray-900" data-id="element-108">
                        99,9%
                      </div>
                      <div className="text-[10px] text-emerald-600 font-medium" data-id="element-109">
                        +0,3%
                      </div>
                    </div>
                    <div className="bg-blue-950/5 rounded-lg p-3" data-id="element-110">
                      <div className="text-[10px] text-blue-800 mb-1" data-id="element-111">
                        Активных
                      </div>
                      <div className="text-sm font-bold text-blue-900" data-id="element-112">
                        2 341
                      </div>
                      <div className="text-[10px] text-blue-800 font-medium" data-id="element-113">
                        Онлайн
                      </div>
                    </div>
                  </div>

                  {/* Mini chart area */}
                  <div className="bg-gray-50 rounded-lg p-3" data-id="element-114">
                    <div className="flex items-center justify-between mb-3" data-id="element-115">
                      <span className="text-[10px] font-medium text-gray-700" data-id="element-116">
                        Объём обработки
                      </span>
                      <span className="text-[10px] text-gray-400" data-id="element-117">
                        За 7 дней
                      </span>
                    </div>
                    <div className="flex items-end gap-1.5 h-12" data-id="element-118">
                      <div className="flex-1 bg-blue-200 rounded-sm" style={{
                      height: '40%'
                    }} data-id="element-119"></div>
                      <div className="flex-1 bg-blue-300 rounded-sm" style={{
                      height: '65%'
                    }} data-id="element-120"></div>
                      <div className="flex-1 bg-blue-400 rounded-sm" style={{
                      height: '50%'
                    }} data-id="element-121"></div>
                      <div className="flex-1 bg-blue-500 rounded-sm" style={{
                      height: '80%'
                    }} data-id="element-122"></div>
                      <div className="flex-1 bg-blue-600 rounded-sm" style={{
                      height: '60%'
                    }} data-id="element-123"></div>
                      <div className="flex-1 bg-blue-700 rounded-sm" style={{
                      height: '90%'
                    }} data-id="element-124"></div>
                      <div className="flex-1 bg-blue-900 rounded-sm" style={{
                      height: '100%'
                    }} data-id="element-125"></div>
                    </div>
                  </div>

                  {/* Document rows */}
                  <div className="space-y-2" data-id="element-126">
                    <div className="flex items-center gap-3 bg-white border border-gray-100 rounded-lg px-3 py-2.5" data-id="element-127">
                      <FileTextIcon className="w-4 h-4 text-blue-800 flex-shrink-0" data-id="element-128" />
                      <div className="flex-1 min-w-0" data-id="element-129">
                        <div className="text-[11px] font-medium text-gray-800 truncate" data-id="element-130">
                          Финансовый_отчёт_Q4.pdf
                        </div>
                        <div className="text-[10px] text-gray-400" data-id="element-131">
                          48 стр. • 2,4 МБ
                        </div>
                      </div>
                      <div className="flex items-center gap-1" data-id="element-132">
                        <CheckCircleIcon className="w-3.5 h-3.5 text-emerald-500" data-id="element-133" />
                        <span className="text-[10px] text-emerald-600 font-medium" data-id="element-134">
                          Готово
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 bg-white border border-gray-100 rounded-lg px-3 py-2.5" data-id="element-135">
                      <FileTextIcon className="w-4 h-4 text-blue-800 flex-shrink-0" data-id="element-136" />
                      <div className="flex-1 min-w-0" data-id="element-137">
                        <div className="text-[11px] font-medium text-gray-800 truncate" data-id="element-138">
                          Договор_NDA_2024.pdf
                        </div>
                        <div className="text-[10px] text-gray-400" data-id="element-139">
                          12 стр. • 890 КБ
                        </div>
                      </div>
                      <div className="flex items-center gap-1" data-id="element-140">
                        <CheckCircleIcon className="w-3.5 h-3.5 text-emerald-500" data-id="element-141" />
                        <span className="text-[10px] text-emerald-600 font-medium" data-id="element-142">
                          Готово
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 bg-white border border-blue-200 rounded-lg px-3 py-2.5" data-id="element-143">
                      <FileTextIcon className="w-4 h-4 text-blue-800 flex-shrink-0" data-id="element-144" />
                      <div className="flex-1 min-w-0" data-id="element-145">
                        <div className="text-[11px] font-medium text-gray-800 truncate" data-id="element-146">
                          Счета_пакет_март.pdf
                        </div>
                        <div className="text-[10px] text-gray-400" data-id="element-147">
                          156 стр. • 8,1 МБ
                        </div>
                      </div>
                      <div className="flex items-center gap-1.5" data-id="element-148">
                        <div className="w-3.5 h-3.5 rounded-full border-2 border-blue-800 border-t-transparent animate-spin" data-id="element-149"></div>
                        <span className="text-[10px] text-blue-800 font-medium" data-id="element-150">
                          Обработка
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating notification card */}
            <div className="absolute -top-2 -right-2 md:top-4 md:-right-6 bg-white rounded-lg shadow-lg border border-gray-200 p-3 max-w-[180px]" data-id="element-151">
              <div className="flex items-start gap-2.5" data-id="element-152">
                <div className="w-7 h-7 bg-emerald-50 rounded-md flex items-center justify-center flex-shrink-0" data-id="element-153">
                  <TrendingUpIcon className="w-3.5 h-3.5 text-emerald-600" data-id="element-154" />
                </div>
                <div data-id="element-155">
                  <p className="text-[11px] font-semibold text-gray-800" data-id="element-156">
                    Точность выросла
                  </p>
                  <p className="text-[10px] text-gray-500" data-id="element-157">
                    99,9% в последней партии
                  </p>
                </div>
              </div>
            </div>

            {/* Floating stats badge */}
            <div className="absolute -bottom-2 -left-2 md:bottom-8 md:-left-4 bg-white rounded-lg shadow-lg border border-gray-200 p-3" data-id="element-158">
              <div className="flex items-center gap-2.5" data-id="element-159">
                <div className="w-7 h-7 bg-blue-950/10 rounded-md flex items-center justify-center flex-shrink-0" data-id="element-160">
                  <BellIcon className="w-3.5 h-3.5 text-blue-900" data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <p className="text-[11px] font-semibold text-gray-800" data-id="element-163">
                    3 документа готовы
                  </p>
                  <p className="text-[10px] text-gray-500" data-id="element-164">Только что</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background gradient */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-gray-100/80 to-transparent -z-10" data-id="element-165"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-gradient-to-tr from-blue-950/5 to-transparent -z-10" data-id="element-166"></div>
    </section>;
}